import http from 'hub-http/clients/apiClient';
import { useEffect, useState } from 'react';
import { createRpcClientV2 } from 'rpc-client-utils';
import { evaluateInAppRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const usePurchaseMotions = ({
  location,
  apiName
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [purchaseMotions, setPurchaseMotions] = useState([]);
  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(undefined);
    setPurchaseMotions([]);
    rpcClient.call(evaluateInAppRpc, {
      request: {
        locations: [location],
        productApiNames: [apiName]
      }
    }).then(response => {
      var _response$purchaseMot;
      if (!isMounted) return;
      const motions = ((_response$purchaseMot = response.purchaseMotionsMapping.productsByLocationString[location]) === null || _response$purchaseMot === void 0 || (_response$purchaseMot = _response$purchaseMot.purchaseMotionsByProductApiName[apiName]) === null || _response$purchaseMot === void 0 ? void 0 : _response$purchaseMot.purchaseMotions.filter(isPurchaseMotion)) || [];
      setPurchaseMotions(motions);
    }).catch(e => {
      if (!isMounted) return;
      const errorObj = e instanceof Error ? e : new Error(String(e));
      setError(errorObj);
    }).finally(() => {
      if (!isMounted) return;
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  }, [location, apiName]);
  return {
    loading,
    error,
    purchaseMotions
  };
};
function isPurchaseMotion(value) {
  return typeof value === 'string';
}